<div class="p-grid">
  <div class="p-col-2 back">
    <app-menu-button [menu]="adminMenu"></app-menu-button>
  </div>
  <div class="p-col-10">
    <app-menu-screen [menus]="menus"></app-menu-screen>
  </div>
</div>
